export enum customModelTypes {
  trainings = "trainings",
  deployments = "deployments",
}
